module.exports = __webpack_public_path__ + "static/CareLabel-v4-no-border-8778752ca9da7f45b05f2fc617268715.svg";